import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal';
import ConfirmDialog from '../common/ConfirmDialog';
import './ModalForms.css';
import '../common/IconButton.css';
import { IconTrash } from '../common/Icons';

const emptyPayment = {
  date: '',
  value: '',
  currency: 'USD',
  type: '',
  detail: '',
  receipt: ''
};

const normalizePaymentType = (type) => {
  const raw = String(type || '').trim();
  const t = raw.toLowerCase();
  if (!t) return '';
  // DB enum uses a typo: "tranferencia"
  if (t === 'transferencia' || t === 'tranferencia') return 'tranferencia';
  if (t === 'efectivo') return 'efectivo';
  if (t === 'credito' || t === 'crédito') return 'Credito';
  return raw;
};

const PaymentModal = ({ isOpen, onClose, onSave, onDelete, initialData }) => {
  const [formData, setFormData] = useState(emptyPayment);
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    if (initialData) {
      setFormData({
        date: initialData.date ? initialData.date.slice(0,10) : '',
        value: initialData.value ?? '',
        currency: initialData.currency || '$',
        type: normalizePaymentType(initialData.type),
        detail: initialData.detail || '',
        receipt: initialData.receipt || ''
      });
    } else {
      const today = new Date().toISOString().slice(0, 10);
      setFormData({ ...emptyPayment, date: today });
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave(formData);
  };

  return (
    <Modal
      title={initialData ? 'Editar Pago' : 'Nuevo Pago'}
      isOpen={isOpen}
      onClose={onClose}
      onEnter={() => handleSubmit()}
      footer={(
        <div className="modal-footer">
          <div className="footer-left">
            {initialData && onDelete && (
              <button
                type="button"
                className="icon-btn icon-btn--delete"
                onClick={() => setConfirmOpen(true)}
                aria-label="Eliminar pago"
                title="Eliminar"
              >
                <IconTrash />
              </button>
            )}
          </div>
          <div className="footer-actions">
            <button type="button" className="btn secondary" onClick={onClose}>Cancelar</button>
            <button type="submit" form="payment-modal-form" className="btn">Guardar</button>
          </div>
        </div>
      )}
    >
      <form id="payment-modal-form" className="modal-form" onSubmit={handleSubmit}>
        <div className="form-grid two-columns">
          <label>
            Fecha
            <input type="date" name="date" value={formData.date} onChange={handleChange} required />
          </label>
          <label>
            Tipo
            <select name="type" value={formData.type} onChange={handleChange} required>
              <option value="" disabled>Seleccionar...</option>
              <option value="tranferencia">Transferencia</option>
              <option value="efectivo">Efectivo</option>
              <option value="Credito">Crédito</option>
            </select>
          </label>
          <label>
            Moneda
            <select name="currency" value={formData.currency} onChange={handleChange}>
              <option value="$">$</option>
              <option value="USD">USD</option>
            </select>
          </label>
          <label>
            Importe
            <input type="number" step="0.01" name="value" value={formData.value} onChange={handleChange} required />
          </label>
          <label>
            Detalle
            <input name="detail" value={formData.detail} onChange={handleChange} />
          </label>
          <label>
            Comprobante
            <input name="receipt" disabled value={formData.receipt} onChange={handleChange} />
          </label>
        </div>
      </form>

      <ConfirmDialog
        isOpen={confirmOpen}
        title="Eliminar pago"
        message="¿Está seguro que desea eliminar este pago?"
        confirmLabel="Eliminar"
        cancelLabel="Cancelar"
        onConfirm={() => {
          setConfirmOpen(false);
          onDelete?.(initialData?.id);
        }}
        onCancel={() => setConfirmOpen(false)}
      />
    </Modal>
  );
};

export default PaymentModal;
